import { Meeting } from "@/schema"
import { Button } from "@ui/shad/button"
import { format } from "date-fns"
import { ArrowUpRight, Sparkles } from "lucide-react"

import { useFetchFeatureFlags } from "@/hooks/api/feature-flags/queries"
import { Link } from "@/components/book-link"
import { DownloadBeneficiaryReport } from "@/components/clients/download-beneficiary-report"

export function BeneficiaryReviewCard({ meeting }: { meeting: Meeting }) {
  const { data: featureFlags } = useFetchFeatureFlags()
  if (!featureFlags?.includes("schwab_api") || meeting.meeting_type !== "client_review") return null
  if (!meeting.beneficiary_reviews?.length) return null

  return (
    <section id="beneficiary-review" className="border-blue-border bg-blue-background mt-4 rounded-lg border p-4">
      <div className="flex items-center gap-2">
        <Sparkles className="text-blue-accent size-4 shrink-0" />
        <h2 className="text-sm font-semibold">Beneficiaries reported by Schwab</h2>
      </div>
      <div className="divide-blue-border divide-y">
        {meeting.beneficiary_reviews.map((review) => (
          <div key={review.household_id} className="space-y-2 pt-3 not-last:pb-3">
            <div>
              <p className="text-sm font-medium">{review.household_name}</p>
              <p className="text-muted-foreground text-xs">
                {review.synced_account_count} of {review.account_count} linked Schwab accounts synced
                {review.synced_at && (
                  <span title={`Oldest account sync: ${format(review.synced_at, "PPpp")}`}>
                    {" · "}Last synced {format(review.synced_at, "MMM d, yyyy")}
                  </span>
                )}
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button size="sm" variant="outline" asChild>
                <Link href={`/clients/${review.household_id}?tab=custodian`} bookIdOverride={meeting.book_id}>
                  View beneficiaries
                  <ArrowUpRight />
                </Link>
              </Button>
              {review.synced_account_count > 0 && (
                <DownloadBeneficiaryReport
                  clientId={review.household_id}
                  accountIds={review.account_ids}
                  bookId={meeting.book_id}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
